import { Extension, Plugin, TextSelection } from 'tiptap'

export default class MaxSize extends Extension {
  get name() {
    return 'maxSize'
  }

  get defaultOptions() {
    return {
      maxSize: null,
    }
  }

  getEditorContentLength(state) {
    const html = this.editor.getHTML()
    const textContent = state.doc.textContent

    if (html !== this.options.emptyComment) {
      const emptyParagraphOccurences = (html.match(/<p><\/p>/g) || []).length
      return textContent.length
        ? textContent.length + emptyParagraphOccurences
        : 0
    }
    return 0
  }

  get plugins() {
    return [
      new Plugin({
        appendTransaction: (transactions, oldState, newState) => {
          const max = this.options.maxSize || this.defaultOptions.maxSize
          const oldDocSize = this.getEditorContentLength(oldState)
          const newDocSize = this.getEditorContentLength(newState)
          const newResPos = newState.selection.$head

          if (newDocSize > oldDocSize && newDocSize > max && max) {
            const overPaste = newDocSize - max
            const newTextSelection = TextSelection.create(
              newState.doc,
              newResPos.pos - overPaste > 0 ? newResPos.pos - overPaste : 0,
              newResPos.pos,
            )
            const newTr = newState.tr
            newTr.setSelection(newTextSelection)
            newTr.deleteSelection()
            return newTr
          }
        },
      }),
    ]
  }
}
